import { createContext, useContext, useState } from "react";
import ReactDOM from "react-dom";

const LoaderContext = createContext();

export const useLoader = () => useContext(LoaderContext);

export const LoaderProvider = ({ children }) => {
  const [loaderTarget, setLoaderTarget] = useState(null); // élément cible
  const [visible, setVisible] = useState(false);

  const showLoader = (selector = null) => {
    setLoaderTarget(selector);
    setVisible(true);
  };

  const hideLoader = () => {
    setVisible(false);
    setLoaderTarget(null);
  };

  return (
    <LoaderContext.Provider value={{ showLoader, hideLoader }}>
      {children}
      {visible && <LoaderPortal selector={loaderTarget} />}
    </LoaderContext.Provider>
  );
};

/* -------------------- Composant d’affichage du Loader -------------------- */
function LoaderPortal({ selector }) {
  const container = selector
    ? document.querySelector(`.${selector}`)
    : document.body;

  if (!container) return null;

  return ReactDOM.createPortal(
    <div className="absolute inset-0 bg-white/80 backdrop-blur-sm flex flex-col items-center justify-center z-50">
      <div className="relative w-24 h-24">
        <div className="absolute inset-0 rounded-full border-4 border-green-400 border-t-transparent animate-spin"></div>
        <div className="absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center text-green-600 text-4xl font-bold animate-pulse">
          ?
        </div>
      </div>
      <p className="mt-4 text-gray-600 font-medium">Chargement...</p>
    </div>,
    container
  );
}
